import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import * as actions from './actions';
import * as selectors from './selectors';
import ChatConversationDescribeEmail from '../ChatConversationDescribeEmail';
import styles from './styles';

class ChatConversationDescribe extends PureComponent {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { init } = this.props;
    init();
  }

  render() {
    const { show } = this.props;

    if (!show) return null;
    return (
      <div className="emailBanner kustomer-app-email-banner-container" style={styles.wrapper}>
        <ChatConversationDescribeEmail />
      </div>
    );
  }
}

ChatConversationDescribe.propTypes = {
  show: PropTypes.bool,
  init: PropTypes.func,
};

ChatConversationDescribe.defaultProps = {
  show: false,
  init: () => {},
};

const mapStateToProps = state => ({
  show: selectors.getShowForCurrentConversation(state),
});

const mapDispatchToProps = dispatch => ({
  init: () => dispatch(actions.handleMaybeShowDescribe()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatConversationDescribe);
